import TableTop from "../TableComponents/TableTop";
import { Table, TableBody, TablePagination } from "@mui/material";
import { TableTopTypeEnum } from "../../../utils/enums/TableTopTypeEnum";
import { handleChangePage, handleChangeRowsPerPage } from "../../../../SharedComponents/utils/helpers/tableHelpers";
import AllActiveRequestsTableHead from "../TableHeads/AllActiveRequestsTableHead";
import AllActiveCarRequestTableRow from "../TableRows/AllActiveRequestsTableRow";


const AllActiveRequestsTable = ({
    count,
    fetchedActiveCarRequests,
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage
}) => {

    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Tekući zahtevi"}
                count={count}
                variant={TableTopTypeEnum.TRANSPARENT}
            />
            <div style={styles.tablePaddingDiv}>
                <div style={styles.tableBorderDiv}>
                    <Table>
                        <AllActiveRequestsTableHead />

                        <TableBody>

                            {fetchedActiveCarRequests.map((row, index) => (
                                <AllActiveCarRequestTableRow
                                    key={index}
                                    carRequest={row}
                                />
                            ))}

                        </TableBody>

                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[15, 25, 50]}
                        component="div"
                        count={count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={(event, newPage) => {
                            handleChangePage(event, newPage, setPage)
                        }}
                        onRowsPerPageChange={(event) => {
                            handleChangeRowsPerPage(
                                event,
                                setRowsPerPage,
                                setPage
                            )
                        }}
                    />
                </div>
            </div>
        </div>
    );
};


export default AllActiveRequestsTable;

const styles = {
    mainContainer: {

    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
    }
};